import "core-js/modules/web.dom.iterable";
/* eslint-disable */
import { toQueryString, toast } from '@ykz/ykz-util/base';
import databus, { Origins } from '@ykz/ykz-http/core';
import { getWeChatList } from '@ykz/ykz-http/common';
export default {
  name: 'buyConsult',
  data: function data() {
    return {
      defaultAvatar: window.comm.defaultUserAvatar,
      fromWeChatId: getUrlParams('fromWeChatId') || 1,
      weChatId: getUrlParams('weChatId') || window.weChatId || 1,
      scenicId: getUrlParams('scenicId') || '',
      storeId: getUrlParams('storeId') || '',
      goodId: getUrlParams('goodId') || '',
      consult: null,
      isGoodsDetails: false,
      // 是否是酒景页
      isStoreDetails: false,
      availableWechatId: false
    };
  },
  mounted: function mounted() {
    console.log('ycf组件初始化：buyConsult');
    window.componentCenter.buyConsult = this;
    this.isGoodsDetails = !!(location.href.indexOf('goodsDetails') > -1);
    this.isStoreDetails = !!(location.href.indexOf('storeDetails') > -1);
    this.ajaxGetConsultList();
    this.ajaxGetWeChatList();
  },
  methods: {
    goAdvisory: function goAdvisory() {
      var that = this,
        url = '/front/index/userAdvisory?' + toQueryString({
          scenicId: that.scenicId,
          storeId: that.storeId,
          weChatId: that.weChatId,
          fromWeChatId: that.fromWeChatId,
          goodId: that.goodId
        });
      if (this.isGoodsDetails || this.isStoreDetails) {
        YCF_Plugin.reportUserAnchors({
          event_id: '520003',
          event_content: {
            item_id: this.scenicId || this.storeId,
            scenicFrom: getUrlParams('scenicFrom') || '',
            element_content: 'clickMoreConsultation'
          },
          page_name: this.isGoodsDetails ? '酒景详情页' : '门店详情页'
        }).always(function () {
          goAdvisoryHelper(YCF_Plugin.getNavigateUrl(url, {}));
        });
      } else {
        goAdvisoryHelper(url);
      }
      function goAdvisoryHelper(url) {
        location.href = url;
      }
    },
    // 获取用户咨询
    ajaxGetConsultList: function ajaxGetConsultList() {
      var that = this;
      databus({
        url: '/apiv2/hotel/getConsultList',
        data: {
          scenicId: that.scenicId || that.storeId || '',
          goodId: that.goodId || '',
          pageIndex: 1,
          pageSize: 1,
          resourceType: that.storeId ? 1 : 0
        },
        type: 'GET',
        success: function success(data) {
          if (data.code === 1000 && data.bcode === 100 && data.content) {
            if (data.content.list && data.content.list.length > 0) {
              that.consult = data.content.list[0];
            } else {
              that.consult = {};
            }
            that.consult.total = data.content.count;
            that.consult.isShowConsultation = data.content.isShowConsultation;
          } else {
            console.log('获取咨询信息失败:' + data.message);
          }
        },
        error: function error() {
          toast('网络有误，请刷新重试');
        }
      });
    },
    // 获取当前公众号是否可以展示评价模块
    ajaxGetWeChatList: function ajaxGetWeChatList() {
      var _this = this;
      if (getUrlParams('weChatId') == 1 && (this.isGoodsDetails || this.isStoreDetails)) {
        this.availableWechatId = true;
        return;
      }
      getWeChatList().then(function (data) {
        if (data.code === 1000 && data.bcode === 100) {
          var wechatList = data.content || [];
          wechatList.forEach(function (item) {
            if (item == _this.weChatId) {
              _this.availableWechatId = true;
            }
          });
        } else {
          console.log('获取公众号信息失败:' + data.message);
        }
      }).catch(function () {
        toast('网络有误，请刷新重试');
      });
    }
  },
  filters: {
    formatTime: function formatTime(time) {
      if (!time * 1) return '';
      var date = new Date(time * 1000),
        year = addZero(date.getFullYear()),
        month = addZero(date.getMonth() + 1),
        day = addZero(date.getDate()),
        hour = addZero(date.getHours()),
        miniute = addZero(date.getMinutes()),
        seconds = addZero(date.getSeconds());
      return year + '-' + month + '-' + day + ' ' + hour + ':' + miniute + ':' + seconds;
      function addZero(num) {
        if (num < 10) {
          return '0' + num;
        }
        return num;
      }
    }
  }
};